import { createContext, useState } from 'react';
import users from '../../constants/users';

const ModalContext = createContext({});
const ModalConsumer = ModalContext.Consumer;

const ModalProvider = ({ children }) => {
    const [regModal, setRegModal] = useState(null);
    const [showSubmitButton, setshowSubmitButton] = useState(true);
    const [phoneModal, setPhoneModal] = useState(false);

    const handleModalClose = () => setRegModal(null);
    const onRegisterClick = (type) => setRegModal(users[type]);
    const onSubmitButtonHide = () => setshowSubmitButton(false);
    const SubmitButtonShow = () => setshowSubmitButton(true);

    return (
        <ModalContext.Provider value={{ regModal, handleModalClose, onRegisterClick, showSubmitButton, onSubmitButtonHide, SubmitButtonShow, phoneModal, setPhoneModal }}>
            {children}
        </ModalContext.Provider>
    );
};

export { ModalContext, ModalProvider, ModalConsumer };